import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { ExpandLess } from '@vedmarket/ui-kit';
import { COLORS } from 'config/constants';

const HelpPanel = ({ title, children, expanded, defaultExpanded, onChange, headerHelp }: HelpPanelProps) => (
  <Accordion
    className='help-panel'
    disableGutters
    expanded={expanded}
    defaultExpanded={defaultExpanded}
    onChange={(_, value) => onChange?.(value)}
    sx={{
      padding: '24px',
      margin: 0,
      borderRadius: 0,
      boxShadow: `inset 0 0 0 1px ${COLORS.SLIGHTLY_GRAY}`,
      backgroundColor: COLORS.LIME,
      '&::before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 0,
      },
    }}
  >
    <div className='help-panel__header'>
      <AccordionSummary expandIcon={<ExpandLess color={COLORS.LIGHT_ACTION} />} sx={{
        minHeight: '24px',
        padding: 0,
        flex: 1,
        minWidth: 0,
        '&.Mui-expanded': {
          minHeight: '24px',
          borderBottom: 0,
        },
        '.MuiAccordionSummary-content': {
          margin: 0,
        },
        '.MuiAccordionSummary-content.Mui-expanded': {
          margin: 0,
        },
        '.MuiAccordionSummary-expandIconWrapper svg': {
          width: '24px',
          height: '24px',
        },
        '.MuiAccordionSummary-expandIconWrapper': {
          transform: 'none',
        },
        '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
          transform: 'none',
        },
      }}>
        <Typography variant='subtitle1' sx={{
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: 0,
          color: COLORS.BLACK_DARK,
        }}>{title}</Typography>
      </AccordionSummary>
      {headerHelp}
    </div>
    <AccordionDetails sx={{ padding: '24px 0 0' }}>{children}</AccordionDetails>
  </Accordion>
);

export default HelpPanel;
